// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__BWe23","bannerVideo":"banners_bannerVideo__HRdT3"};